import { CANDIDATE_INPUT_INFO_TYPES, LOCAL_STORAGE_USER_LOGIN_INFO } from "@app/constants/Common";
import React, { useEffect, useState } from 'react';

import {
    CANDIDATE_LANGUAGES_FIELDS,
    LANGUAGE_SKILL_OPTIONS,
    RC_CANDIDATE_LANGUAGES_FIELDS
} from "@app/constants/Languages";
import { CandidateDetailLanguageMode } from "@app/constants/Tabs";
import * as CandidateService from "@app/services/CandidateService";
import { searchAllInputInfo } from "@app/services/CandidateService";
import { checkExistsCommonFieldValues } from "@app/utils/CandidateUtils";
import { optionsToString, stringToArray, stringToOption } from "@app/utils/CommonUtils";
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";
import Select from "react-select";
import { toast } from "react-toastify";

const CandidateLanguageComponent = (props) => {
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [languages, setLanguages] = useState({});
    const [objStrLanguages, setObjStrLanguages] = useState({});
    const [allInputInfo, setAllInputInfo] = useState([]);
    const [languageFields, setLanguageFields] = useState(CANDIDATE_LANGUAGES_FIELDS);
    const [isEdit, setIsEdit] = useState(false);

    const {
        candidateId,
        initStrLanguages,
        initObjLanguages,
        isAllUsers,
        onChange,
        mode = CandidateDetailLanguageMode.DETAIL,
    } = props

    const allLanguageFields = {...CANDIDATE_LANGUAGES_FIELDS, ...RC_CANDIDATE_LANGUAGES_FIELDS}

    useEffect(() => {
        if (initObjLanguages) {
            setLanguages({...initObjLanguages});
            // setObjStrLanguages(optionsToString([...initLanguages]));
        }
    }, [initObjLanguages]);

    useEffect(() => {
        if (initStrLanguages) {
            setObjStrLanguages(initStrLanguages);
        }
    }, [initStrLanguages]);

    const fetchCandidateLanguages = async (canId) => {
        if (!canId) {
            return;
        }
        let allInputs = []
        if (mode !== CandidateDetailLanguageMode.SEARCH) {
            allInputs = await searchAllInputInfo(canId, CANDIDATE_INPUT_INFO_TYPES.CandidateLanguage)
            setAllInputInfo([...allInputs])
        }

        CandidateService.getCandidateLanguages(canId, isAllUsers).then((res) => {
            const resContent = res.content
            resContent.allLanguagesInfo = allInputs
            setObjStrLanguages({...resContent});
            const lang = {candidate_id: candidateId, allLanguagesInfo: allInputs}
            Object.keys(resContent).map(field => {
                const fieldItem = allLanguageFields[field]
                if (fieldItem) {
                    if (fieldItem.type === "option") {
                        lang[field] = stringToOption(resContent[field], fieldItem.isMulti, true)
                    } else {
                        lang[field] = resContent[field]
                    }
                }

                return field
            })
            setLanguages(lang)
            if (onChange) {
                onChange({...resContent})
            }
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        })
    };

    const updateCandidateLanguages = () => {
        // Check xem trong số các trường sử dụng chung, giá trị đã đc nhập bởi user khác cho UV này chưa
        // Nếu có user khác nhập cho UV này giá trị rồi => báo lỗi, ko save thông tin vào DB.
        if (checkExistsCommonFieldValues(languages, userLoginInfo.id)) {
            return;
        }

        const updateFields = (mode === CandidateDetailLanguageMode.RC || mode === CandidateDetailLanguageMode.SEARCH_RC)
            ? RC_CANDIDATE_LANGUAGES_FIELDS
            : CANDIDATE_LANGUAGES_FIELDS;
        const updateLanguages = {};
        Object.keys(updateFields).forEach((field) => {
            updateLanguages[field] = optionsToString(languages[field]);
        });

        const requestBody = {candidate_id: candidateId, languages: updateLanguages}
        CandidateService.updateCandidateLanguages(requestBody).then((res) => {
            console.log(JSON.stringify(res))
            toast.success(`Cập nhật thông tin thành công.`);
            setIsEdit(false)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        })
    };

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    },[]);
    useEffect(() => {
        if (candidateId) {
            fetchCandidateLanguages(candidateId)
        }
    },[candidateId]);

    const onChangeLanguage = (fieldName, values) => {
        languages[fieldName] = [...values];
        setLanguages({...languages});

        objStrLanguages[fieldName] = optionsToString(values);
        // setObjStrLanguages({...objStrLanguages});
        if (onChange) {
            return onChange(objStrLanguages, languages)
        }
        return ""
    }

    const onChangeLanguageNotes = (event) => {
        languages[event.target.name] = event.target.value;
        setLanguages({...languages});

        objStrLanguages[event.target.name] = event.target.value;
        if (onChange) {
            return onChange(objStrLanguages, languages)
        }
        return ""
    }

    const onSaveLanguages = () => {
        updateCandidateLanguages()
    }
    useEffect(() => {
        if (mode === CandidateDetailLanguageMode.RC || mode === CandidateDetailLanguageMode.SEARCH_RC) {
            setLanguageFields(RC_CANDIDATE_LANGUAGES_FIELDS)
        }
    }, [mode])

    const hasEditButton = () => {
        return (mode === CandidateDetailLanguageMode.DETAIL || mode === CandidateDetailLanguageMode.RC)
    }

    const onCopyFromCategoryAndFlowTab = () => {
        languages.rc_english = Array.from(new Set([
            ...(languages.rc_english || []), ...(allInputInfo.flatMap(item => stringToOption(item.english)))
        ]));
        languages.rc_france = Array.from(new Set([
            ...(languages.rc_france || []), ...(allInputInfo.flatMap(item => stringToOption(item.france)))
        ]));
        languages.rc_china = Array.from(new Set([
            ...(languages.rc_china || []), ...(allInputInfo.flatMap(item => stringToOption(item.china)))
        ]));
        languages.rc_korea = Array.from(new Set([
            ...(languages.rc_korea || []), ...(allInputInfo.flatMap(item => stringToOption(item.korea)))
        ]));
        languages.rc_japanese = Array.from(new Set([
            ...(languages.rc_japanese || []), ...(allInputInfo.flatMap(item => stringToOption(item.japanese)))
        ]));
        languages.rc_russian = Array.from(new Set([
            ...(languages.rc_russian || []), ...(allInputInfo.flatMap(item => stringToOption(item.russian)))
        ]));

        if (languages.others) {
            if (!languages.rc_others) {
                languages.rc_others = languages.others;
            } else if (!languages.rc_others.contains(languages.others)) {
                languages.rc_others += " " + languages.others;
            }
        }

        if (languages.common_notes) {
            if (!languages.rc_common_notes) {
                languages.rc_common_notes = languages.common_notes;
            } else if (!languages.rc_common_notes.contains(languages.common_notes)) {
                languages.rc_common_notes += " " + languages.common_notes;
            }
        }

        Object.keys(RC_CANDIDATE_LANGUAGES_FIELDS).forEach(field => {
            objStrLanguages[field] = optionsToString(languages[field]);
        })

        setLanguages({...languages})
    }

    return (
        // <div className='container-fluid'>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Ngôn ngữ</h3>
                    <div className={'card-tools'}>
                        <div className={''}>
                            <>
                                {hasEditButton() && isEdit &&
                                <button type='button'
                                        className='btn btn-default mr-2'
                                        onClick={() => {
                                            setIsEdit(false);
                                        }}
                                        >
                                    Cancel
                                </button>
                                }
                                {hasEditButton() && isEdit && mode === CandidateDetailLanguageMode.RC &&
                                <button type='button'
                                        className='btn btn-default mr-2'
                                        onClick={onCopyFromCategoryAndFlowTab}>
                                    Copy từ tab languages
                                </button>
                                }

                                {(mode === CandidateDetailLanguageMode.EXTRACT
                                        || ( hasEditButton() && isEdit)
                                    ) &&
                                <button type='button'
                                        className='btn btn-info mr-2'
                                        onClick={() => {
                                            onSaveLanguages();
                                        }}
                                        >
                                    Save
                                </button>
                                }
                                {hasEditButton() && !isEdit &&
                                <button type='button'
                                        className='btn btn-default'
                                        onClick={() => {
                                            setIsEdit(true);
                                        }}
                                        >
                                    Edit
                                </button>
                                }
                            </>
                        </div>
                    </div>
                </div>
                <div className='card-body'>
                    <div className={"row"}>
                        {Object.keys(languageFields).map(field => {
                            const langField = languageFields[field]
                            if (langField.type === "option") {
                                return <div className='input-group mt-3' key={`candidate_languages_fields_${field}`}>
                                    <label className={'w-100'}><b>{langField.title}</b></label>
                                    <div style={{width: '100%'}}>
                                        <Select options={LANGUAGE_SKILL_OPTIONS} isMulti
                                                value={languages[field] || []}
                                                isDisabled={hasEditButton() && !isEdit}
                                                onChange={value => {
                                                    onChangeLanguage(field, value);
                                                }}
                                        />
                                    </div>
                                    {mode !== CandidateDetailLanguageMode.SEARCH &&
                                        <AllUserInputField arrInfo={allInputInfo} field={field} />
                                    }
                                </div>
                            }
                            if (langField.type === "text") {
                                return <div className='input-group mt-3' key={`candidate_languages_fields_${field}`}>
                                    <label className={'w-100'}><b>{langField.title}</b></label>
                                    <input type='text' className='form-control'
                                           value={languages[field] || ''}
                                           name={field}
                                           disabled={hasEditButton() && !isEdit}
                                           onChange={event => onChangeLanguageNotes(event)}/>
                                    {mode !== CandidateDetailLanguageMode.SEARCH &&
                                        <AllUserInputField arrInfo={allInputInfo} field={field}/>
                                    }
                                </div>
                            }
                            return ""
                        })}
                    </div>
                </div>
            </div>
        // </div>
    );
};

export default CandidateLanguageComponent;
